import React, { useMemo } from "react";
import { useRedeemsUIContext } from "../RedeemsUIContext";

export function RedeemsGrouping() {
  // Redeems UI Context
  const redeemsUIContext = useRedeemsUIContext();
  const redeemsUIProps = useMemo(() => {
    return {
      ids: redeemsUIContext.ids,
      setIds: redeemsUIContext.setIds,
      openDeleteRedeemsDialog: redeemsUIContext.openDeleteRedeemsDialog,
      openFetchRedeemsDialog: redeemsUIContext.openFetchRedeemsDialog,
      openUpdateRedeemsStatusDialog:
        redeemsUIContext.openUpdateRedeemsStatusDialog,
    };
  }, [redeemsUIContext]);

  return (
    <div className="form">
      <div className="row align-items-center form-group-actions margin-top-20 margin-bottom-20">
        <div className="col-xl-12">
          <div className="form-group form-group-inline">
            <div className="form-label form-label-no-wrap">
              <label className="font-bold font-danger">
                <span>
                  Selected records count: <b>{redeemsUIProps.ids.length}</b>
                </span>
              </label>
            </div>
            <div>
              &nbsp;
              <button
                type="button"
                className="btn btn-light-primary font-weight-bolder font-size-sm"
                onClick={redeemsUIProps.openUpdateRedeemsStatusDialog}
              >
                <i className="fa fa-sync-alt"></i> Update Status
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
